import { render, staticRenderFns } from "./SpecialtyList.vue?vue&type=template&id=4a17729c&scoped=true&"
import script from "./SpecialtyList.vue?vue&type=script&lang=js&"
export * from "./SpecialtyList.vue?vue&type=script&lang=js&"
import style0 from "./SpecialtyList.vue?vue&type=style&index=0&id=4a17729c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a17729c",
  null
  
)

export default component.exports